import axios from 'axios';

// Get all part types
export const getPartTypes = async () => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get('/api/parts/types', {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching part types' };
  }
};

// Get all parts
export const getParts = async (filters = {}) => {
  try {
    let queryString = '';
    if (filters.type) queryString += `type=${filters.type}&`;
    if (filters.search) queryString += `search=${encodeURIComponent(filters.search)}&`;
    if (filters.part_type_id) queryString += `part_type_id=${filters.part_type_id}&`;

    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/parts?${queryString}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching parts' };
  }
};

// Get part by ID
export const getPartById = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.get(`/api/parts/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error fetching part details' };
  }
};

// Create new part
export const createPart = async (partData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.post('/api/parts', partData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error creating part' };
  }
};

// Update part
export const updatePart = async (id, partData) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.put(`/api/parts/${id}`, partData, {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error updating part' };
  }
};

// Delete part
export const deletePart = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const res = await axios.delete(`/api/parts/${id}`, {
      headers: {
        'x-auth-token': token
      }
    });
    return res.data;
  } catch (error) {
    throw error.response?.data || { message: 'Error deleting part' };
  }
};